<div *ngFor="let sidebar of sidebars" (click)="addSidebar(sidebar.name)" class="sidebar">
  <ion-icon [src]="sidebar.icon"></ion-icon>
  <span>{{ sidebar.name }}</span>
</div>
